import { useState, useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/UI/Button/Button';
import { FilterLabelBox } from 'components/UI/FilterLabelBox/FilterLabelBox';
import { EventFiltersContext } from '../../Shared/EventFiltersProvider';
import {
  getActiveFilterObject,
  getActiveFilterLabel,
} from '../../WhatsOnGenre/whats-on-genre-utils';

export const ActiveFilters = (props) => {
  const { filterSet, setEventFilters } = props;
  const { appliedFilters, setAppliedFilters, isLoading } = useContext(EventFiltersContext);
  const [showActiveFilters, setShowActiveFilters] = useState();
  const activeFiltersRef = useRef(null);

  const removeSingleFilterHandler = (itemId) => {
    const newFilters = appliedFilters
      .map((filterItem) => {
        const newSelectedOptions = filterItem.SelectedOptions.filter(
          (filterId) => itemId !== filterId
        );

        return newSelectedOptions.length
          ? {
              ...filterItem,
              SelectedOptions: newSelectedOptions,
            }
          : null;
      })
      .filter((item) => item !== null);

    setAppliedFilters(newFilters);
    setEventFilters(newFilters);
  };

  const filtersDisplayList = (
    <ul>
      {appliedFilters.map((filter, index) => {
        const { FilterId, SelectedOptions } = filter;
        const filterSetObject = getActiveFilterObject(filterSet, FilterId);

        return SelectedOptions.map((selectedItemId) => {
          const filterObjectItems = getActiveFilterLabel(filterSetObject[0].Items, selectedItemId);
          const filterDescription = filterObjectItems[0].Description;

          return (
            <li key={selectedItemId}>
              <FilterLabelBox
                extendClass="active-filters__label filter-tag"
                text={filterDescription}
                disabled={isLoading}
                key={index}
                onClickHandler={() => {
                  removeSingleFilterHandler(selectedItemId);
                }}
              />
            </li>
          );
        });
      })}
    </ul>
  );

  const clearFilterText = 'Clear selected filters';

  const showFiltersOnMobileHandler = () => {
    setShowActiveFilters(!showActiveFilters);
  };

  const clearAllFiltersHandler = () => {
    setAppliedFilters([]);
    setEventFilters([]);
  };

  // Close the active filters when clicked outside of it
  useEffect(() => {
    const handler = (event) => {
      if (
        showActiveFilters &&
        activeFiltersRef.current &&
        !activeFiltersRef.current.contains(event.target)
      ) {
        setShowActiveFilters(false);
      }
    };

    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [showActiveFilters]);

  return (
    <div className="active-filters">
      {appliedFilters.length > 0 && (
        <div className="container">
          <div className={`dropdown ${showActiveFilters ? 'open' : ''}`} ref={activeFiltersRef}>
            <Button
              extendClass="active-filters__button visible-xs btn-block btn-toggle-text btn-small"
              onClick={showFiltersOnMobileHandler}
            >
              <span className="toggle-text-wrap text-right">
                <span className="toggle-text default-text">Show</span>
                <span className="toggle-text alt-text">Hide</span>
              </span>{' '}
              active filters
            </Button>

            <div className="filter-tags dropdown-menu active-filters__labels">
              <ul>
                <li>
                  <FilterLabelBox
                    extendClass="active-filters__label filter-tag"
                    text={clearFilterText}
                    disabled={isLoading}
                    key="clear-all"
                    onClickHandler={clearAllFiltersHandler}
                  />
                </li>
              </ul>

              {filtersDisplayList}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ActiveFilters.propTypes = {
  filterSet: PropTypes.array,
  setEventFilters: PropTypes.func,
};
